import { defineMessages } from 'react-intl'

export const imagesMessages = defineMessages({
  labelWithRegNo: {
    id: 'images.labelWithRegNo',
    defaultMessage: '{vehicleRegNo} kuvat',
  },
  label: {
    id: 'images.label',
    defaultMessage: 'Kuvat',
  },
  uploadErrorTitle: {
    id: 'images.uploadErrorTitle',
    defaultMessage: 'Virhe',
  },
  tooManyFiles: {
    id: 'images.tooManyFiles',
    defaultMessage: 'Voit ladata enintään {limit} tiedostoa kerralla. Valittuna on {count} tiedostoa.',
  },
  uploadFailed: {
    id: 'images.uploadFailed',
    defaultMessage: 'Virhe kuvien lataamisessa palvelimelle',
  },
  fetchFailedTitle: {
    id: 'images.fetchFailedTitle',
    defaultMessage: 'Virhe!',
  },
  fetchFailed: {
    id: 'images.fetchFailed',
    defaultMessage: 'Kuvien hakeminen palvelimelta epäonnistui',
  },
  deleteConfirmLabel: {
    id: 'images.deleteConfirmLabel',
    defaultMessage: 'Poistetaanko kuva',
  },
  deleteConfirmMessage: {
    id: 'images.deleteConfirmMessage',
    defaultMessage: 'Vahvista kuvan poistaminen',
  },
  deleteConfirmClose: {
    id: 'images.deleteConfirmClose',
    defaultMessage: 'Peruuta',
  },
  takePhoto: {
    id: 'images.takePhoto',
    defaultMessage: 'Ota kuva',
  },
  uploadPhoto: {
    id: 'images.uploadPhoto',
    defaultMessage: 'Lataa kuva',
  },
  noImages: {
    id: 'images.noImages',
    defaultMessage: 'Kuormakirjalle ei ole lisätty kuvia',
  },
  fileTooLarge: {
    id: 'images.fileTooLarge',
    defaultMessage: 'Tiedosto on liian suuri',
  },
  uploadSuccessTitle: {
    id: 'images.uploadSuccessTitle',
    defaultMessage: 'Valmis',
  },
  uploadSuccess: {
    id: 'images.uploadSuccess',
    defaultMessage: 'Kuvat ladattu palvelimelle',
  },
  delete: {
    id: 'images.delete',
    defaultMessage: 'Poista',
  },
})
